<script lang="ts">
	import '$lib/app.css';
	let { value = $bindable(''), error = '', success = '', ...rest } = $props();

	let inputEl: HTMLInputElement;
	function clear() {
		value = '';
		inputEl.focus();
	}

	export function focus() {
		inputEl.focus();
	}
</script>

<div class="inline-block">
	<div class="relative">
		<input
			class="form-control"
			class:error
			class:success={success && !error}
			bind:this={inputEl}
			bind:value
			{...rest}
		/>
		{#if value}
			<button
				type="button"
				class="absolute top-1/2 right-0 mr-1 -translate-y-1/2 rounded bg-gray-100 px-1 text-sm"
				onclick={clear}
				aria-label="Clear text"
			>
				&times;
			</button>
		{/if}
	</div>
	{#if error}
		<p class="mt-1 text-sm text-red-500">{error}</p>
	{:else if success}
		<p class="mt-1 text-sm text-green-500">{success}</p>
	{/if}
</div>
